import { ComponentProps } from "react";
import { View, ViewProps } from "react-native";

import { createBox } from "../theme";

export const Box = createBox<ViewProps>(View);

export type BoxProps = ComponentProps<typeof Box>;

export type MarginProps = Pick<
  BoxProps,
  "m" | "mt" | "mr" | "mb" | "ml" | "mx" | "my"
>;
